export * from '@primeuix/themes/lara/terminal';
export { default } from '@primeuix/themes/lara/terminal';
